// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_1krcx","dbox":"index_dbox_YOxyo"};